export const MESSENGER_SERVICE_TYPES = {
  MessengerService: Symbol('MessengerService'),
};

interface MessengerService {
  appointmentScheduled(): void;
  cancelScheduling(): void;
  finishedScheduling(): void;
}

export default MessengerService;
